﻿import $ from "jquery";
import { EditableItemList, MovingDirection } from "./editableItemList";

export class EditableTextInputItemList extends EditableItemList<string> {

    init(divElementId: string) {
        this.itemList = $(`#${divElementId}`).data("initial");

        super.init(divElementId,"addRegistrationField");
    }

    protected drawItem(item: string, itemId: number) {
        const itemElement = "<div class='field has-addons'>" +
            "<div class='control'>" +
            "<input id='inputField-" + itemId + "' class='input' type='text' name='RegistrationToChange.InputFields[" + itemId + "]' value='" + item + "'>" +
            "</div>" +
            "<div class='control'>" +
            "<button id='inputFieldMoveUp-" + itemId + "' class='button' data-tooltip='Eingabefeld nach hoch schieben'>" +
            "<span class='icon is-small'>" +
            "<i class='fas fa-arrow-up'></i>" +
            "</span>" +
            "</button>" +
            "</div>" +
            "<div class='control'>" +
            "<button id='inputFieldMoveDown-" + itemId + "' class='button' data-tooltip='Eingabefeld nach unten schieben'>" +
            "<span class='icon is-small'>" +
            "<i class='fas fa-arrow-down'></i>" +
            "</span>" +
            "</button>" +
            "</div>" +
            "<div class='control'>" +
            "<button id='inputFieldRemove-" + itemId + "' class='button' data-tooltip='Eingabefeld entfernen'>" +
            "<span class='icon is-small'>" +
            "<i class='fas fa-times'></i>" +
            "</span>" +
            "</button>" +
            "</div>" +
            "</div>";
        $(`#${this.divElementId}`).append(itemElement);

        $(`#inputField-${itemId}`).change(() => {
            this.itemList[itemId] = String($(`#inputField-${itemId}`).val());
        });

        $(`#inputFieldMoveUp-${itemId}`).click(() => {
            this.moveItem(MovingDirection.Up, itemId);
            this.redrawItems();
        });

        $(`#inputFieldMoveDown-${itemId}`).click(() => {
            this.moveItem(MovingDirection.Down, itemId);
            this.redrawItems();
        });

        $(`#inputFieldRemove-${itemId}`).click(() => {
            this.itemList.splice(itemId, 1);
            this.redrawItems();
        });
    }

    protected addNewItem() {
        this.itemList.push("");
    }
}